import RobotoRegularUrl from "./Roboto_Condensed-Regular.ttf";
import RobotoBoldUrl from "./Roboto_Condensed-Bold.ttf";

function arrayBufferToBinaryString(buffer) {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  const chunkSize = 0x8000;

  for (let i = 0; i < bytes.length; i += chunkSize) {
    const chunk = bytes.subarray(i, i + chunkSize);
    binary += String.fromCharCode(...chunk);
  }

  return binary;
}

async function fetchFontAsBinary(url) {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Nie udało się wczytać fontu: ${url}`);
  }

  const buffer = await response.arrayBuffer();
  return arrayBufferToBinaryString(buffer);
}

export async function loadFonts(doc) {
  const regularBinary = await fetchFontAsBinary(RobotoRegularUrl);
  const boldBinary = await fetchFontAsBinary(RobotoBoldUrl);

  doc.addFileToVFS("Roboto-Regular.ttf", regularBinary);
  doc.addFont("Roboto-Regular.ttf", "Roboto", "normal");

  doc.addFileToVFS("Roboto-Bold.ttf", boldBinary);
  doc.addFont("Roboto-Bold.ttf", "Roboto", "bold");
}